import { render } from "./LingquRecord.vue?vue&type=template&id=7aea854d&scoped=true"
import script from "./LingquRecord.vue?vue&type=script&lang=js"
export * from "./LingquRecord.vue?vue&type=script&lang=js"

import "./LingquRecord.vue?vue&type=style&index=0&id=7aea854d&lang=stylus&scoped=true"

import exportComponent from "D:\\GameProject\\h5yaoji\\H5-client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7aea854d"]])

export default __exports__